import { type Colors } from '@factorialco/deprecated-design-system'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { Shift } from 'modules/shift_management/lib/types'

export const useColor = (shift: Shift): Colors => {
  const [{ shiftsConflicts }] = useSchedule()

  const shiftConflict = useUnsafeMemo(
    () => shiftsConflicts.has(shift.id),
    [shiftsConflicts, shift.id]
  )

  if (shift.isBackup) return 'grey300'
  if (shiftConflict) return 'radicalRed200'

  return shift.color || 'grey400'
}
